/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type BelowValueConfigKind = (typeof BelowValueConfigKind)[keyof typeof BelowValueConfigKind];

export const BelowValueConfigKind = {
  below: 'below',
} as const;
